import { defineMessages } from 'react-intl';
import { VERTICALS } from '../Search.constants';

export const messages = defineMessages({
  [VERTICALS.all]: {
    id: 'search.search-box.message.all',
    defaultMessage: 'All',
  },
  [VERTICALS.gym]: {
    id: 'search.search-box.message.gym',
    defaultMessage: 'All gyms',
  },
  [VERTICALS.fitness]: {
    id: 'search.search-box.message.fitness',
    defaultMessage: 'All fitness',
  },
  [VERTICALS.wellness]: {
    id: 'search.search-box.message.wellness',
    defaultMessage: 'All wellness',
  },
  listViewTogglerLabel: {
    id: 'search.listViewTogglerLabel',
    defaultMessage: 'List',
  },
  mapViewTogglerLabel: {
    id: 'search.mapViewTogglerLabel',
    defaultMessage: 'Map',
  },
});
